module.exports = new __parcel__URL__("insight-object-view-linked-objects-skeleton.tpl.ba10f51b.svg").toString();